import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { conditionalStyle, textUnderlineOnHover } from '@/theme';

export const StyledLink = styled(LinkWithLocale)<{
  disabled: boolean;
  $isActive: boolean;
  $underline: boolean;
}>`
  text-decoration: none;

  ${({ disabled, theme }) => css`
    border-bottom: 1px solid ${theme.colors.mediumGrey};

    ${conditionalStyle(disabled, 'opacity', 0.5)};
    ${conditionalStyle(disabled, 'pointer-events', 'none')};
  `}

  ${textUnderlineOnHover};
`;

export const NavigationItem = styled(Flex)`
  justify-content: space-between;
  align-content: center;

  ${({ theme }) => css`
    margin-top: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(2)};
  `};
`;
